export const sideBarContent = [
  {
    id: 1,
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/home-loan-1737028012223.webp",
    data: "Home Loan Balance Transfer with MinEMI: Save More on Your Mortgage",
    link: "/calculators/financial-insights-and-tools/home-loan-balance-transfer-blog",
  },
  {
    id: 2,
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/credit-card-1737027764144.webp",
    data: "Minemi Credit Card Balance Transfer Calculator",
    link: "/calculators/financial-insights-and-tools/credit-card-balance-transfer-blog",
  },
  {
    id: 3,
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/personal-bt-loan-1738393201640.webp",
    data: "Personal Loan Balance Transfer with MinEMI: Save More on Your Loan",
    link: "/calculators/financial-insights-and-tools/personal-loan-balance-transfer-blog",
  },
  {
    id: 4,
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/car-bt-loan-1738393420849.webp",
    data: "Car Loan Balance Transfer with MinEMI: Drive Your Savings Further",
    link: "/calculators/financial-insights-and-tools/car-loan-balance-transfer-blog",
  },
];
